import { detailsList } from './details';

// 品版LOGO设计
let brandJson = [];
for (let i = 0; i < 20; i++) {
    brandJson.push({
        id: detailsList['brand_'+(i+1)].id,
        icon: detailsList['brand_'+(i+1)].icon,
        name: detailsList['brand_'+(i+1)].name,
    })
}

// 软件服务
let serveJson = [];
for (let i = 0; i < 20; i++) {
    serveJson.push({
        id: detailsList['serve_'+(i+1)].id,
        icon: detailsList['serve_'+(i+1)].icon,
        name: detailsList['serve_'+(i+1)].name,
    })
}

// 电子商务
let businessJson = [];
for (let i = 0; i < 20; i++) {
    businessJson.push({
        id: detailsList['business_'+(i+1)].id,
        icon: detailsList['business_'+(i+1)].icon,
        name: detailsList['business_'+(i+1)].name,
    })
}

export {
    brandJson, 
    serveJson,
    businessJson,
};